import { ErrorHandler, inject, Injectable } from '@angular/core'
import { ExceptionHelperService } from './exception-helper.service'
import { ExceptionSeverity } from './exception-severity.enum'
import { environment } from '../../../environments/environment'

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private exceptionHelper = inject(ExceptionHelperService)

  handleError(error: any): void {
    if (this.exceptionHelper.isSyncfusionFirstChildError(error)) {
      return
    }
    // Add breadcrumb for the error
    this.exceptionHelper.addBreadcrumb('Unhandled Error', 'error', { error: error.message || 'Unknown error' })

    // Capture the error with default severity
    this.exceptionHelper.captureException(error, ExceptionSeverity.ERROR, {
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
    })

    // Log to console in development
    if (!environment.production) {
      console.error('Global error handler caught an error:', error)
    }
  }
}
